<template>
  <div
    :class="`opple-button ${type} ${size} ${disabled ? ' disabled': ''}${loading ? ' loading' : ''} ${className}`"
    @click="handlerClick"
  >
    <div
      class="opple-button_container"
    >
      <i
        v-if="loading"
        class="el-icon-loading"  
      />
      <i 
        v-if="!!icon && !loading"
        :class="icon"
      />
      <slot />
    </div>
  </div>
</template>

<script>
import { debounce } from "@utils/utils";

export default {
  name: 'OppleButton',
  comments: {
  },
  props: {
    className: {
      type: String,
      default: '', // 自定义类名
    },
    size: {
      type: String,
      default: 'medium', // 尺寸 medium | small | mini
    },
    type: {
      type: String,
      default: 'primary', // primary 蓝色 | default 白色 | danger 红色
    },
    loading: {
      type: Boolean,
      default: false, // 是否加载中 [变淡 不可点击]
    },
    disabled: {
      type: Boolean,
      default: false, // 是否禁用 [变淡  不可点击]
    },
    icon: {
      type: String,
      default: null, // 图标icon ele的图标 不传则没有
    },
  },
  data() {
    return {
    };
  },

  mounted() {
  },

  methods: {
    /**
     * 点击事件 自带防抖
     */
    handlerClick: debounce(function (e) {
      if (this.loading || this.disabled) return;

      this.$emit('click', e);
    })
  },
};
</script>

<style lang="scss">
.opple-button {
  display: inline-block;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;

  &.medium {
    min-width: 70px;
    padding: 9px 14px;
  }

  &.small {
    min-width: 48px;
    padding: 6px 10px;
    font-size: 14px;
  }

  &.mini {
    min-width: 34px;
    padding: 4px 8px;
    font-size: 12px;
  }

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &_container {
    display: flex;
    justify-content: center;
    align-items: center;
    
    i {
      margin-right: 5px;
    }
  }

  &.loading {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &.primary {
    background-color: #1B45A4;
    color: #fff;
  }

  &.danger {
    background-color: #dd2b0e;
    color: #fff;
    font-weight: bold;
  }

  &.default {
    background-color: #fff;
    color: #1B45A4;
    border: 1px solid #1B45A4;
  }
}
</style>
